var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('b-breadcrumb',{staticClass:"w-100",attrs:{"items":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }